import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import budgetReducer from './slices/budget';
import catalogReducer from './slices/catalog';
import adminReportsReducer from './slices/adminReports';
import contractsReducer from './slices/contracts';
import dashboardReducer from './slices/dashboard';
import emailRecipientReducer from './slices/emailRecipient';
import invoicingReducer from './slices/invoicing';
import notificationsReducer from './slices/notifications';
import orderGuidesReducer from './slices/orderGuides';
import ordersReducer from './slices/orders';
import orderSheetReducer from './slices/orderSheet';
import rentalsReducer from './slices/rentals';
import reportsReducer from './slices/reports';
import ticketReducer from './slices/tickets';
import transitionsReducer from './slices/transitions';
import transportsReducer from './slices/transports';
import userReducer from './slices/user';
import usersReducer from './slices/users';
import vendorsReducer from './slices/vendors';

export const userPersistConfig = {
    key: 'cart',
    storage,
    keyPrefix: 'redux-',
    whitelist: ['user'],
};

// Function to create a store for a specific tab
export function createStoreForTab(tabKey) {
    const rootReducer = combineReducers({
        budget: budgetReducer,
        catalog: catalogReducer,
        contracts: contractsReducer,
        adminReports: adminReportsReducer,
        dashboard: dashboardReducer,
        invoicing: invoicingReducer,
        notifications: notificationsReducer,
        orderGuides: orderGuidesReducer,
        orderSheet: orderSheetReducer,
        orders: ordersReducer,
        tickets: ticketReducer,
        user: persistReducer(userPersistConfig, userReducer),
        users: usersReducer,
        vendors: vendorsReducer,
        emailRecipient: emailRecipientReducer,
        rentals: rentalsReducer,
        reports: reportsReducer,
        transitions: transitionsReducer,
        transports: transportsReducer,
    });

    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: false,
            }),
        devTools: {
            name: `Tab-${tabKey}`, // Name your store based on the tabKey
        },
    });
}
